// frontend/src/admin/blockforms/ImageForm.js
import React, { useState, useEffect } from 'react';
import { buildBlockSave } from './blockSaveTarget';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://80.225.197.31:8001';

const ImageForm = ({ level, entityId, section, editingBlock, nextOrderIndex, onSaved, onCancel }) => {
    const existing = editingBlock?.content_data || {};

    const [imageUrl, setImageUrl] = useState(existing.image_url || '');
    const [orientation, setOrientation] = useState(existing.orientation || 'horizontal');
    const [captionEn, setCaptionEn] = useState(existing.en?.caption || '');
    const [captionHi, setCaptionHi] = useState(existing.hi?.caption || '');
    const [uploading, setUploading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const hasUnsavedChanges = imageUrl || captionEn || captionHi;
        if (!hasUnsavedChanges) return;

        const handleBeforeUnload = (e) => {
            e.preventDefault();
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [imageUrl, captionEn, captionHi]);

    const handleImageUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setUploading(true);
        try {
            const formData = new FormData();
            formData.append('file', file);
            const res = await fetch(`${API_BASE}/rich-content/upload-image`, {
                method: 'POST',
                body: formData
            });
            if (!res.ok) throw new Error('Upload failed');
            const data = await res.json();
            setImageUrl(data.file_path);
        } catch (err) {
            setError('Image upload failed');
        } finally {
            setUploading(false);
        }
    };

    const handleSave = async () => {
        if (!imageUrl) {
            setError('Please upload an image');
            return;
        }
        setError(null);
        setSaving(true);

        const content_data = {
            image_url: imageUrl,
            orientation,
            en: { caption: captionEn }
        };
        if (captionHi) {
            content_data.hi = { caption: captionHi };
        }

        const { url, method, payload } = buildBlockSave({
            level, entityId, section, editingBlock,
            blockType: 'image',
            contentData: content_data,
            orderIndex: nextOrderIndex,
        });

        try {
            const res = await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (!res.ok) {
                const err = await res.json();
                throw new Error(err.detail || 'Save failed');
            }
            onSaved();
        } catch (err) {
            setError(err.message);
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="ace-form">
            <h4>{editingBlock ? 'Edit' : 'Add'} Image</h4>
            {error && <div className="ace-error">{error}</div>}

            <label>Image *</label>
            <input type="file" accept="image/*" onChange={handleImageUpload} disabled={uploading} />
            {imageUrl && (
                <div className="ace-image-preview">
                    <img src={imageUrl.startsWith('http') ? imageUrl : `${API_BASE}/${imageUrl}`} alt="" />
                </div>
            )}

            <label>Orientation</label>
            <select value={orientation} onChange={(e) => setOrientation(e.target.value)}>
                <option value="horizontal">Horizontal</option>
                <option value="vertical">Vertical</option>
            </select>

            <label>Caption (English)</label>
            <input type="text" value={captionEn} onChange={(e) => setCaptionEn(e.target.value)} />

            <label>Caption (Hindi, optional)</label>
            <input type="text" value={captionHi} onChange={(e) => setCaptionHi(e.target.value)} />

            <div className="ace-form-actions">
                <button onClick={handleSave} disabled={saving}>{saving ? 'Saving...' : 'Save'}</button>
                <button onClick={onCancel} className="ace-cancel-btn">Cancel</button>
            </div>
        </div>
    );
};

export default ImageForm;